"use client";

import React, { useState } from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Zap, Droplets, Leaf } from "lucide-react";
export default function AgriculturalEmpowerment() {
  return <section data-section-id="236731" id="the-future-pathways-to-success-center" className="dark bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 md:mb-16 text-center">
          <div className="inline-block px-4 py-1.5 mb-6 text-xs font-bold tracking-widest uppercase rounded-full bg-primary/20 text-primary border border-primary/30">
            Future Vision
          </div>
          <h2 className="font-default text-3xl md:text-4xl lg:text-6xl font-bold text-foreground mb-4 tracking-tight">
            Mary E. Jiles and Gregory J. Hand Pathways to Success Center
          </h2>
          <p className="font-default text-base md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            A signature initiative in development, designed to be a beacon of stability, dignity, and long-term transformation for our community.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          {}
          <div className="flex justify-center">
            <img src="https://solid-silkworm.10web.cloud/wp-content/uploads/2026/04/Apr-28-2026-05_11_13-PM.png" alt="Modern architectural rendering of the Pathways to Success Center" className="w-full max-w-md rounded-3xl shadow-2xl border border-border/50 backdrop-blur-sm" />
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground mb-6">
              Strategic Development Goals
            </h3>
            
            <Accordion type="single" collapsible className="border border-border rounded-2xl overflow-hidden bg-card/50 backdrop-blur-md">
              {}
              <AccordionItem value="component-a" className="border-b last:border-b-0">
                <AccordionTrigger className="px-4 md:px-6 hover:bg-accent/20 transition-colors">
                  <div className="flex items-center gap-3">
                    <Zap className="text-primary" size={20} />
                    <span className="font-default font-semibold text-foreground">
                      Phase I: Foundation & Planning
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 md:px-6 bg-card/30 text-muted-foreground">
                  <p className="mb-3">
                    Establishing the legal and architectural framework for a facility that prioritizes human dignity. This phase focuses on securing community partnerships and finalizing the sustainable design of the center.
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm">
                    <li>Community resource navigation hub</li>
                    <li>Sustainable architectural blueprints</li>
                    <li>Founders Circle initial funding round</li>
                  </ul>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="component-b" className="border-b last:border-b-0">
                <AccordionTrigger className="px-4 md:px-6 hover:bg-accent/20 transition-colors">
                  <div className="flex items-center gap-3">
                    <Droplets className="text-primary" size={20} />
                    <span className="font-default font-semibold text-foreground">
                      Phase II: Integrated Support Services
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 md:px-6 bg-card/30 text-muted-foreground">
                  <p className="mb-3">
                    Developing the core service infrastructure, including dedicated spaces for mentorship, life skills development, and case management to ensure every individual has a personalized pathway to success.
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm">
                    <li>Mentorship and personal development suites</li>
                    <li>Life skills and vocational training labs</li>
                    <li>Comprehensive reentry support systems</li>
                  </ul>
                </AccordionContent>
              </AccordionItem>

              {}
              <AccordionItem value="component-c" className="border-b last:border-b-0">
                <AccordionTrigger className="px-4 md:px-6 hover:bg-accent/20 transition-colors">
                  <div className="flex items-center gap-3">
                    <Leaf className="text-primary" size={20} />
                    <span className="font-default font-semibold text-foreground">
                      Phase III: Independent Living Readiness
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 md:px-6 bg-card/30 text-muted-foreground">
                  <p className="mb-3">
                    The final vision includes supportive housing priorities and transition services that empower individuals to move toward independent living with confidence and stability.
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm">
                    <li>Supportive housing priority planning</li>
                    <li>Transportation services coordination</li>
                    <li>Long-term community reintegration</li>
                  </ul>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        {}
        <div className="bg-card/40 rounded-3xl p-8 md:p-12 mb-16 border border-border shadow-xl backdrop-blur-sm">
          <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground mb-8 text-center">
            Our TRUST Core Values in Action
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="space-y-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto">
                <Zap className="text-primary" size={24} />
              </div>
              <h4 className="font-default font-semibold text-foreground text-center">
                Truth & Responsibility
              </h4>
              <p className="text-muted-foreground text-center text-sm">
                Building a foundation of honesty and accountability to foster genuine personal growth and community trust.
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto">
                <Droplets className="text-primary" size={24} />
              </div>
              <h4 className="font-default font-semibold text-foreground text-center">
                Understanding & Skills
              </h4>
              <p className="text-muted-foreground text-center text-sm">
                Providing the empathy and practical tools necessary for individuals to navigate their unique journeys.
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto">
                <Leaf className="text-primary" size={24} />
              </div>
              <h4 className="font-default font-semibold text-foreground text-center">
                Thoughtfulness
              </h4>
              <p className="text-muted-foreground text-center text-sm">
                A community-centered approach that treats every person with the dignity and respect they deserve.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="bg-primary/10 rounded-3xl p-8 md:p-12 border border-primary/20 shadow-inner">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground mb-4">
              Join the Founders Circle
            </h3>
            <p className="text-muted-foreground mb-8 text-base">
              Be part of the initial group of supporters helping build the foundation for long-term impact and transformational community support.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full font-semibold px-8">
                Support the Vision
              </Button>
              <Link to="/SupportUsPage" className="no-underline">
                <Button size="lg" variant="outline" className="w-full sm:w-auto rounded-full border-primary/30 hover:bg-primary/5">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}